module.exports = __webpack_public_path__ + "img/arrow-customize-house-right.b8c18aab.svg";